import { SIZE_OPTIONS } from '../../../constants/sizes';
import THREE from '../utils/threeClassesAdapter';

export class Component3D extends THREE.Group {
    _winWidth = 1;
    _winHeight = 1;
    _pixelRatio = 1;
    _orientation = SIZE_OPTIONS.LANDSCAPE;

    constructor() {
        super();

        this._setup();
    }

    _setup() {
        // Set to true and override method setupPreloadedContent to construct instances needed preload
        // e.g. Text meshes
        this.waitForPreload = false;

        // Set to true and override method resize to enable resize
        this.hasResize = false;

        // Set to true and override method start to make ThemesApp fire start method
        this.hasStart = false;

        // The flags to make ThemesApp fire invalidate or set progress value for scrollable or scrubbing animation
        // Set to true and add method invalidate
        this.hasInvalidate = false;
        // Set to true and add method updateProgress
        this.hasProgressUpdate = false;
        // Set to true in order to listen to actions
        this.clickable = false;
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        if (!this.hasResize) return;

        let orientationChanged = force;
        let changed = force;

        if (winWidth) {
            changed = this._winWidth !== winWidth || changed;
            this._winWidth = winWidth;
        }
        if (winHeight) {
            changed = this._winHeight !== winHeight || changed;
            this._winHeight = winHeight;
        }
        if (orientation) {
            orientationChanged = this._orientation !== orientation || orientationChanged;
            changed = orientationChanged || changed;
            this._orientation = orientation;
        }
        if (pixelRatio) this._pixelRatio = pixelRatio;

        if (!changed) return;

        this._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);
    }

    // eslint-disable-next-line class-methods-use-this
    _resize() {
        // Override this method to enable resizing
        // PARAMETERS ORDER:
        // winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio
    }

    // eslint-disable-next-line class-methods-use-this
    invalidate() {
        // Override this method to accomplish time-based animation
        // PARAMETERS ORDER:
        // t, dt
    }

    // eslint-disable-next-line class-methods-use-this
    updateProgress() {
        // Override this method to accomplish progress-based changes
        // PARAMETERS ORDER:
        // value
    }

    // eslint-disable-next-line class-methods-use-this
    start() {
        // Override this method to accomplish start click/over listeners
    }

    // eslint-disable-next-line class-methods-use-this
    destroy() {
        // Override this method to remove extra-listeners, timeouts and gsap timelines
    }

    // eslint-disable-next-line class-methods-use-this
    setupPreloadedContent(/* infrastructure */) {
        // Override this method to accomplish zoom-In changes
        // PARAMETERS ORDER:
        // infrastructure
    }
}
